export interface IOptionServiceDTO {
  Title: string;
  Value: string;
}

export interface IOption {
  value: string;
  title: string;
  disabled: boolean;
  visible: boolean;
  id(): string;
  type(): string;
}

export class OptionBase implements IOption {
  public value: string;
  public title: string;
  public disabled: boolean;
  public visible: boolean;

  private hiddenType = '';
  private idSuffix = '';

  constructor(type: string, cfg?: any) {
    if (cfg === null || typeof cfg !== 'object') {
      cfg = {};
    }

    this.value = cfg.value || '';
    this.title = cfg.title || '';
    this.disabled = false;
    this.visible = true;

    this.idSuffix = String(Math.random()).substr(2);
    this.hiddenType = type;
  }

  public id(): string {
    return this.value.toLowerCase().replace(/\s/g, '-') + '_' + this.idSuffix;
  }

  public type(): string {
    return this.hiddenType;
  }
}

export class CheckboxOption extends OptionBase {
  constructor(cfg?: any) {
    super('checkbox', cfg);
  }
}

export class RadioOption extends OptionBase {
  constructor(cfg?: any) {
    super('radio', cfg);
  }
}
